import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Spin, Input } from 'hljd'
import style from './style.module.less'
import CaseItem from './CaseItem'
import { getCaseManageTitle } from '@util'
@observer
export default class extends Component {
  list

  componentDidMount() {
    this.list.addEventListener('scroll', this.checkScrollToBottom)
  }

  componentWillUnmount() {
    this.list.removeEventListener('scroll', this.checkScrollToBottom)
  }

  checkScrollToBottom = () => {
    const {
      caseListHasNext,
      getCaseListLoading,
      getCaseList
    } = this.props.store
    const { list } = this
    const listH = list.offsetHeight
    const scrollH = list.scrollHeight
    const scrollTop = list.scrollTop
    if (
      !getCaseListLoading &&
      caseListHasNext &&
      listH + scrollTop >= scrollH - 5
    ) {
      getCaseList()
    }
  }

  render() {
    const {
      caseList,
      // saveCase,
      // preSetMeal 不能删
      // eslint-disable-next-line no-unused-vars
      preSetMeal,
      refresh,
      searchParam,
      handleChangeSearchParam,
      handleChangeCaseList,
      getCaseListLoading
    } = this.props.store
    return (
      <Spin spinning={getCaseListLoading}>
        <div className={style.caseEditor1}>
          <div className={style.editorBar}>
            <p className={style.editorTitle}>
              <Input
                value={searchParam}
                placeholder={'输入关键字搜索'}
                onChange={e => {
                  handleChangeSearchParam(e)
                  handleChangeCaseList(e)
                }}
              />
            </p>
            <div className={style.editorbuttonGroup}>
              {/* <Button className={style.item} onClick={refresh}>
              刷新
            </Button> */}
              <a className={style.refreshBtn} onClick={refresh}>
                刷新
              </a>
              {/* <Button
              className={style.item}
              type="primary"
              onClick={() => {
                window.open('#/localMerchant/case')
              }}
            >
              {getCaseManageTitle()}
            </Button> */}
              <a
                className={style.manage}
                onClick={() => {
                  window.open('#/localMerchant/case')
                }}
              >
                {getCaseManageTitle()}
              </a>
            </div>
          </div>
          <div className={style.editorCenter}>
            <div className={style.caseContent} ref={list => (this.list = list)}>
              <div className={style.case}>
                {caseList.map((el, i) => (
                  <CaseItem
                    key={i}
                    index={i}
                    data={el}
                    store={this.props.store}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </Spin>
    )
  }
}
